import {
  mockCameraHealth,
  mockEvidence,
  mockForensicResults,
  mockHeatmapZones,
  mockIncidentTimeline,
  mockIncidents,
  mockDashboard,
  mockMapCameras,
  mockMeta,
  mockRiskScores,
} from "../../mocks/fixtures/platformMockData";

export const platformMockService = {
  getMeta: () => mockMeta,
  getDashboard: () => mockDashboard,
  getMapCameras: () => mockMapCameras,
  getRiskScores: () => mockRiskScores,
  getIncidents: () => mockIncidents,
  getIncidentTimeline: () => mockIncidentTimeline,
  getEvidence: () => mockEvidence,
  getHeatmapZones: () => mockHeatmapZones,
  getCameraHealth: () => mockCameraHealth,
  getForensicResults: () => mockForensicResults,
};
